module.exports = __webpack_public_path__ + "static/artist-marketing-the-process-035e853748f541123f8b20919132a46e.webp";